import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { openLocation } from '@jbrowse/core/util/io';
import { objectHash } from '@jbrowse/core/util';
import { generateUnknownTrackConf, generateUnsupportedTrackConf, guessAdapter, guessTrackType, UNKNOWN, UNSUPPORTED } from '@jbrowse/core/util/tracks';
export function convertTrackConfig(jb1TrackConfig, dataRoot, sequenceAdapter) {
  var jb2TrackConfig = {
    trackId: objectHash(jb1TrackConfig),
    name: jb1TrackConfig.key || jb1TrackConfig.label
  };
  var description = jb1TrackConfig.metadata && (jb1TrackConfig.metadata.description || jb1TrackConfig.metadata.Description);
  if (description) {
    jb2TrackConfig.description = description;
  }
  var category = jb1TrackConfig.category || jb1TrackConfig.metadata && jb1TrackConfig.metadata.category;
  jb2TrackConfig.category = category ? category.split(/\s*\/\s*/) : [];
  var storeClass = jb1TrackConfig.storeClass;
  if (!jb1TrackConfig.urlTemplate) {
    if (!(storeClass && storeClass.endsWith('FromConfig'))) {
      var trackIdentifier = jb1TrackConfig.key || jb1TrackConfig.label;
      console.warn("Could not import JBrowse1 track \"".concat(trackIdentifier, "\" because it does not have a \"urlTemplate\" or is not a \"FromConfig\" track"));
      return generateUnsupportedTrackConf(jb2TrackConfig.name, trackIdentifier, jb2TrackConfig.category);
    }
    return generateFromConfigTrackConfig(jb1TrackConfig, jb2TrackConfig);
  }
  var resolveUrlTemplate = function resolveUrlTemplate(urlTemplate) {
    return new URL(urlTemplate, "".concat(dataRoot, "/")).href.replace(/%7B/gi, '{').replace(/%7D/gi, '}');
  };
  var urlTemplate = resolveUrlTemplate(jb1TrackConfig.urlTemplate);
  if (storeClass) {
    if (storeClass === 'JBrowse/Store/SeqFeature/BAM') {
      var adapter = {
        type: 'BamAdapter',
        bamLocation: {
          uri: urlTemplate,
          locationType: 'UriLocation'
        }
      };
      if (jb1TrackConfig.baiUrlTemplate) {
        adapter.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.baiUrlTemplate),
            locationType: 'UriLocation'
          }
        };
      } else if (jb1TrackConfig.csiUrlTemplate) {
        adapter.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.csiUrlTemplate),
            locationType: 'UriLocation'
          },
          indexType: 'CSI'
        };
      } else {
        adapter.index = {
          location: {
            uri: "".concat(urlTemplate, ".bai"),
            locationType: 'UriLocation'
          }
        };
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'AlignmentsTrack',
        adapter: adapter
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/CRAM') {
      var _adapter = {
        type: 'CramAdapter',
        cramLocation: {
          uri: urlTemplate,
          locationType: 'UriLocation'
        },
        sequenceAdapter: sequenceAdapter
      };
      if (jb1TrackConfig.craiUrlTemplate) {
        _adapter.craiLocation = {
          uri: resolveUrlTemplate(jb1TrackConfig.craiUrlTemplate),
          locationType: 'UriLocation'
        };
      } else {
        _adapter.craiLocation = {
          uri: "".concat(urlTemplate, ".crai"),
          locationType: 'UriLocation'
        };
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'AlignmentsTrack',
        adapter: _adapter
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/NCList') {
      return _objectSpread({}, jb2TrackConfig, {
        type: 'FeatureTrack',
        adapter: {
          type: 'NCListAdapter',
          rootUrlTemplate: {
            uri: urlTemplate,
            locationType: 'UriLocation'
          }
        }
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/BigWig' || storeClass === 'JBrowse/Store/BigWig') {
      if (jb1TrackConfig.type && jb1TrackConfig.type.endsWith('XYPlot')) {
        jb2TrackConfig.defaultRendering = 'xyplot';
      } else if (jb1TrackConfig.type && jb1TrackConfig.type.endsWith('Density')) {
        jb2TrackConfig.defaultRendering = 'density';
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'QuantitativeTrack',
        adapter: {
          type: 'BigWigAdapter',
          bigWigLocation: {
            uri: urlTemplate,
            locationType: 'UriLocation'
          }
        }
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/VCFTabix') {
      var _adapter2 = {
        type: 'VcfTabixAdapter',
        vcfGzLocation: {
          uri: urlTemplate,
          locationType: 'UriLocation'
        }
      };
      if (jb1TrackConfig.tbiUrlTemplate) {
        _adapter2.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.tbiUrlTemplate),
            locationType: 'UriLocation'
          }
        };
      } else if (jb1TrackConfig.csiUrlTemplate) {
        _adapter2.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.csiUrlTemplate),
            locationType: 'UriLocation'
          },
          indexType: 'CSI'
        };
      } else {
        _adapter2.index = {
          location: {
            uri: "".concat(urlTemplate, ".tbi"),
            locationType: 'UriLocation'
          }
        };
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'VariantTrack',
        adapter: _adapter2
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/VCFTribble') {
      return generateUnsupportedTrackConf(jb2TrackConfig.name, "VCFTribble (".concat(urlTemplate, ")"), jb2TrackConfig.category);
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/GFF3') {
      return _objectSpread({}, jb2TrackConfig, {
        type: 'FeatureTrack',
        adapter: {
          type: 'Gff3Adapter',
          gffLocation: {
            uri: urlTemplate,
            locationType: 'UriLocation'
          }
        }
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/BigBed') {
      return _objectSpread({}, jb2TrackConfig, {
        type: 'FeatureTrack',
        adapter: {
          type: 'BigBedAdapter',
          bigBedLocation: {
            uri: urlTemplate,
            locationType: 'UriLocation'
          }
        }
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/GFF3Tabix') {
      var _adapter3 = {
        type: 'Gff3TabixAdapter',
        gffGzLocation: {
          uri: urlTemplate,
          locationType: 'UriLocation'
        }
      };
      if (jb1TrackConfig.tbiUrlTemplate) {
        _adapter3.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.tbiUrlTemplate),
            locationType: 'UriLocation'
          }
        };
      } else if (jb1TrackConfig.csiUrlTemplate) {
        _adapter3.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.csiUrlTemplate),
            locationType: 'UriLocation'
          },
          indexType: 'CSI'
        };
      } else {
        _adapter3.index = {
          location: {
            uri: "".concat(urlTemplate, ".tbi"),
            locationType: 'UriLocation'
          }
        };
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'FeatureTrack',
        adapter: _adapter3
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/BED') {
      return generateUnsupportedTrackConf(jb2TrackConfig.name, "BED (".concat(urlTemplate, ")"), jb2TrackConfig.category);
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/BEDTabix') {
      var _adapter4 = {
        type: 'BedTabixAdapter',
        bedGzLocation: {
          uri: urlTemplate,
          locationType: 'UriLocation'
        }
      };
      if (jb1TrackConfig.tbiUrlTemplate) {
        _adapter4.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.tbiUrlTemplate),
            locationType: 'UriLocation'
          }
        };
      } else if (jb1TrackConfig.csiUrlTemplate) {
        _adapter4.index = {
          location: {
            uri: resolveUrlTemplate(jb1TrackConfig.csiUrlTemplate),
            locationType: 'UriLocation'
          },
          indexType: 'CSI'
        };
      } else {
        _adapter4.index = {
          location: {
            uri: "".concat(urlTemplate, ".tbi"),
            locationType: 'UriLocation'
          }
        };
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'FeatureTrack',
        adapter: _adapter4
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/GTF') {
      return _objectSpread({}, jb2TrackConfig, {
        type: 'FeatureTrack',
        adapter: {
          type: 'GtfAdapter',
          gtfLocation: {
            uri: urlTemplate,
            locationType: 'UriLocation'
          }
        }
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/StaticChunked' || storeClass === 'JBrowse/Store/Sequence/StaticChunked') {
      return generateUnsupportedTrackConf(jb2TrackConfig.name, "StaticChunked (".concat(urlTemplate, ")"), jb2TrackConfig.category);
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/UnindexedFasta') {
      return generateUnsupportedTrackConf(jb2TrackConfig.name, "UnindexedFasta (".concat(urlTemplate, ")"), jb2TrackConfig.category);
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/IndexedFasta') {
      var _adapter5 = {
        type: 'IndexedFastaAdapter',
        fastaLocation: {
          uri: urlTemplate,
          locationType: 'UriLocation'
        }
      };
      if (jb1TrackConfig.faiUrlTemplate) {
        _adapter5.faiLocation = {
          uri: resolveUrlTemplate(jb1TrackConfig.faiUrlTemplate),
          locationType: 'UriLocation'
        };
      } else {
        _adapter5.faiLocation = {
          uri: "".concat(urlTemplate, ".fai"),
          locationType: 'UriLocation'
        };
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'SequenceTrack',
        adapter: _adapter5
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/BgzipIndexedFasta') {
      var _adapter6 = {
        type: 'BgzipFastaAdapter',
        fastaLocation: {
          uri: urlTemplate,
          locationType: 'UriLocation'
        }
      };
      if (jb1TrackConfig.faiUrlTemplate) {
        _adapter6.faiLocation = {
          uri: resolveUrlTemplate(jb1TrackConfig.faiUrlTemplate),
          locationType: 'UriLocation'
        };
      } else {
        _adapter6.faiLocation = {
          uri: "".concat(urlTemplate, ".fai"),
          locationType: 'UriLocation'
        };
      }
      if (jb1TrackConfig.gziUrlTemplate) {
        _adapter6.gziLocation = {
          uri: resolveUrlTemplate(jb1TrackConfig.gziUrlTemplate),
          locationType: 'UriLocation'
        };
      } else {
        _adapter6.gziLocation = {
          uri: "".concat(urlTemplate, ".gzi"),
          locationType: 'UriLocation'
        };
      }
      return _objectSpread({}, jb2TrackConfig, {
        type: 'ReferenceSequenceTrack',
        adapter: _adapter6
      });
    }
    if (storeClass === 'JBrowse/Store/SeqFeature/TwoBit') {
      return _objectSpread({}, jb2TrackConfig, {
        type: 'ReferenceSequenceTrack',
        adapter: {
          type: 'TwoBitAdapter',
          twoBitLocation: {
            uri: urlTemplate,
            locationType: 'UriLocation'
          }
        }
      });
    }
  }
  // If we don't recognize the store class, make a best effort to guess by file type
  jb2TrackConfig.adapter = guessAdapter({
    uri: urlTemplate,
    locationType: 'UriLocation'
  }, undefined, urlTemplate);
  if (!jb2TrackConfig.adapter) {
    throw new Error('Could not determine adapter');
  }
  if (jb2TrackConfig.adapter.type === UNSUPPORTED) {
    return generateUnsupportedTrackConf(jb2TrackConfig.name, urlTemplate, jb2TrackConfig.category);
  }
  if (jb2TrackConfig.adapter.type === UNKNOWN) {
    return generateUnknownTrackConf(jb2TrackConfig.name, urlTemplate, jb2TrackConfig.category);
  }
  jb2TrackConfig.type = guessTrackType(jb2TrackConfig.adapter.type);
  if (jb2TrackConfig.type === 'QuantitativeTrack') {
    if (jb1TrackConfig.type && jb1TrackConfig.type.endsWith('XYPlot')) {
      jb2TrackConfig.defaultRendering = 'xyplot';
    } else if (jb1TrackConfig.type && jb1TrackConfig.type.endsWith('Density')) {
      jb2TrackConfig.defaultRendering = 'density';
    }
  }
  return jb2TrackConfig;
}
function generateFromConfigTrackConfig(jb1TrackConfig, jb2TrackConfig) {
  var jb1Features = jb1TrackConfig.features || [];
  var jb2Features = jb1Features.map(function (feature) {
    var jb2Feature = JSON.parse(JSON.stringify(feature));
    jb2Feature.refName = feature.seq_id;
    jb2Feature.uniqueId = "".concat(feature.seq_id, ":").concat(feature.start, "-").concat(feature.end, ":").concat(feature.name || '');
    return jb2Feature;
  });
  jb2TrackConfig.adapter = {
    type: 'FromConfigAdapter',
    features: jb2Features
  };
  jb2TrackConfig.type = 'FeatureTrack';
  return jb2TrackConfig;
}
export function createRefSeqsAdapter(_x) {
  return _createRefSeqsAdapter.apply(this, arguments);
}
function _createRefSeqsAdapter() {
  _createRefSeqsAdapter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(refSeqs) {
    var refSeqsJson, refSeqsData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (typeof refSeqs === 'string') {
            // assume refSeqs is a url if it is string
            refSeqs = {
              url: refSeqs
            };
          }
          // check refseq urls
          if (!refSeqs.url) {
            _context.next = 15;
            break;
          }
          if (!refSeqs.url.match(/.fai$/)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", {
            type: 'IndexedFastaAdapter',
            fastaLocation: {
              uri: refSeqs.url.slice(0, -4),
              locationType: 'UriLocation'
            },
            faiLocation: {
              uri: refSeqs.url,
              locationType: 'UriLocation'
            }
          });
        case 4:
          if (!refSeqs.url.match(/.2bit$/)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", {
            type: 'TwoBitAdapter',
            twoBitLocation: {
              uri: refSeqs.url,
              locationType: 'UriLocation'
            }
          });
        case 6:
          if (!refSeqs.url.match(/.fa$/)) {
            _context.next = 8;
            break;
          }
          throw new Error('Unindexed FASTA adapter not available');
        case 8:
          if (!refSeqs.url.match(/.sizes/)) {
            _context.next = 10;
            break;
          }
          throw new Error('chromosome SIZES adapter not available');
        case 10:
          _context.next = 12;
          return openLocation({
            uri: refSeqs.url,
            locationType: 'UriLocation'
          }).readFile('utf8');
        case 12:
          refSeqsJson = _context.sent;
          refSeqsData = JSON.parse(refSeqsJson);
          return _context.abrupt("return", refSeqAdapterFromConfig(refSeqsData));
        case 15:
          if (!('data' in refSeqs)) {
            _context.next = 17;
            break;
          }
          return _context.abrupt("return", refSeqAdapterFromConfig(refSeqs.data || []));
        case 17:
          throw new Error("Could not determine adapter for JBrowse1 refSeqs: ".concat(refSeqs.url || JSON.stringify(refSeqs)));
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createRefSeqsAdapter.apply(this, arguments);
}
function refSeqAdapterFromConfig(refSeqsData) {
  var features = refSeqsData.map(function (refSeq) {
    return {
      refName: refSeq.name,
      uniqueId: refSeq.name,
      start: refSeq.start,
      end: refSeq.end
    };
  });
  return {
    type: 'FromConfigAdapter',
    features: features
  };
}